import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import useVehicleType from "../features/entry-exit/hooks/useVehicleType";

const RequireAuth = () => {
  const token = localStorage.getItem("token");
  const userType = localStorage.getItem("userType");
  const { twoWheelerId, fourWheelerId } = useVehicleType();
  const location = useLocation();

  // Dynamic paths for refund reports
  const carsRefundReport = `/cars-refund-report/${fourWheelerId}`;
  const bikesRefundReport = `/bikes-refund-report/${twoWheelerId}`;

  // Define allowed paths for each user type
  const protectedPaths = {
    ADMIN: [
      "/dashboard",
      "/cashcollect",
      "/cashcollect/view/CASH",
      "/cashcollect/view/UPI",
      "/cashcollect/view/CARD",
      "/transaction",
      "/transaction/view",
      "/shift-master",
      "/entrybooth",
      "/reports",
      "/floor",
      // "/block",
      "/fee",
      "/slot",
      "/slotcount",
      "/attendence",
      "/parking-type",
      "/collections",
      "/vehicle",
      "/parkingtype",
      "/paymentmode",
      "/location-master",
      "/staffonboard",
      "/staffonboarding",
      "/extra-charges",
      "/profile-settings",
      "/shift-type",
      "/complimentary-details",
      "/settlement-report",
      "/cars",
      "/bikes",
      carsRefundReport,
      bikesRefundReport,
      "/home",
      "/home/:gateName",
      "/home/:gateName/:gateId",
      "/home/entry-gate/:gateId/vehicle/:vehicleId",
      "/home/exit-gate/:gateId/vehicle/:vehicleId",
      "/entry",
      "/exit",
      "/area",
      "/cashcollect/view/:id",
      "/exitbooth",
      // "/shiftmaster/assign",
      // "/shiftmaster",
      // "/shiftmaster/history",
      // "/shiftmaster/test",
      "/complimentary-details",
      "/cars-refund-report/:id",
      "/bikes-refund-report/:id",
    ],
    SUPERVISOR: [
      "/dashboard",
      "/transaction",
      "/cashcollect",
      "/settlement-report",
      "/complimentary-details",
      "/attendence",
      "/parking-type",
      "/profile-settings",
    ],
    USER: [
      "/home",
      "/home/:gateName",
      "/home/:gateName/:gateId",
      "/home/entry-gate/:gateId/vehicle/:vehicleId",
      "/home/exit-gate/:gateId/vehicle/:vehicleId",
      "/entry",
      "/exit",
      "/cars",
      "/bikes",
      "/cars-refund-report/:id",
      "/bikes-refund-report/:id",
      "/complimentary-details",
    ],
  };

  const publicPaths = [];

  const allowedPaths = protectedPaths[userType] || [];

  const isAllowed =
    allowedPaths.some(
      (path) =>
        path === location.pathname ||
        (path.includes("/:") &&
          location.pathname.startsWith(path.split("/:")[0]))
    ) ||
    publicPaths.some(
      (path) =>
        path === location.pathname ||
        (path.includes("/:") &&
          location.pathname.startsWith(path.split("/:")[0]))
    );

  if (!token) {
    return <Navigate to="/" replace />;
  }

  if (!isAllowed) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default RequireAuth;
